import React from 'react';
import { Container } from 'react-bootstrap';
import Header from './Header.js';
import { Link, useParams } from 'react-router-dom';

import essayInfo from '../essays/EssayInfo.js'

let formatDate = function(date){
    let year = date.substring(0,4);
    let month = date.substring(4,6);
    let day = date.substring(6,date.length);
    return month+"-"+day+"-"+year;
}

let getLink = function(essay,index){
        if("component" in essay) return <Link to={essay.url} key={index}>{essay.title}</Link>
        return <a href={essay.url} key={index}>{essay.title}</a>
    }

let renderLinks = function(){
    return <div id="links">
        <div id="EssayHeader"><h3 id="Essays">Essays</h3>
        <p>Research papers I've writen on topics such as creativity, mythology, spirituality, ecology, and the environment.</p>
        </div>
        <hr/>
        <div id="EssayBody">
            {essayInfo.map((essay, index) => 
                <div key={index}>
                    {getLink(essay,index)}
                    <small className="date"><i>&nbsp;—&nbsp;{formatDate(essay.date)}</i></small>
                    {(index !=0 && index%3==0) ? <hr/> : <br/>}
                </div>
                )}
        </div>
        {/*<b><Link to="/about">What is Henserver?</Link></b>*/}
    </div>
}

let getEssay = function(url){
    for(let i = 0; i < essayInfo.length; i++){
        if(essayInfo[i].url.split('/').pop() === url){
            if ("component" in essayInfo[i]) return essayInfo[i].component;
        }
    }  
    return "";
}

// Get the essay OR render the links
const essays = ({match}) => {
    const { essay } = useParams()
    return (
        <div id="page">
            <Header /> 
            <Container id="body">
                <div id="essays" className="more-stuff-page">
                    { getEssay(essay || "") || renderLinks() }
                </div>
            </Container>
        </div>
    );
}
export default essays;
